import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 26",
	xmlns: "http://www.w3.org/2000/svg",
	style: {
		width: "100%",
		height: "100%",
		color: "#ffffff"
	},
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Слушать" }), /* @__PURE__ */ _jsx("path", {
		d: "M7.712 22.04a.732.732 0 0 1-.806.007.767.767 0 0 1-.406-.703V4.656c0-.31.135-.544.406-.703.271-.16.54-.157.806.006l14.458 8.332c.266.163.4.4.4.709 0 .31-.134.546-.4.71L7.712 22.04z",
		fill: "currentColor",
		fillRule: "evenodd"
	})]
});
export default SvgPlay;
